module.exports = __webpack_public_path__ + "media/תלמיד.35c6a77d.mp3";